import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const UploadButton = styled.span<IWithSize>`
  background-color: #00a541;
  border-radius: 3px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  padding: ${({ size }) => (size ? 5 * size : 5)}px
    ${({ size }) => (size ? 10 * size : 10)}px;
`
export default UploadButton
